import { AfterViewInit, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@static/services/auth.service';

@Component({
  selector: 'app-error',
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent implements AfterViewInit {
  private _authService: AuthService = inject(AuthService);
  private _router: Router = inject(Router);

  ngAfterViewInit(): void {
    if (this._authService.loginDisplay) {
      this._router.navigate(['/projects']);
    } else {
      this._authService.login();
    }
  }
}
